export class TextFieldParameter {
  minLength: number | undefined;
  maxLength: number | undefined;
  regex: string;
  rows: number;
  regexInvalidValue: string;
  regexValidValue: string;
  regexErrorMessage: string;

  constructor() {
    this.rows = 1;
    this.regex = '';
    this.regexInvalidValue = '';
    this.regexValidValue = '';
    this.regexErrorMessage = '';
  }
}
